import React from 'react';
import axios from 'axios';
import {
  Loading, ToastNotification, Table, TableHead, TableRow,
  TableHeader, TableBody, TableData, Accordion, AccordionItem,
  UnorderedList, ListItem,
} from 'carbon-components-react';
import { t } from '../../RI18n';
import './style.css';

class OutdatedActions extends React.Component {
  static anyOutdatedActions(response) {
    let actionsFound = false;
    if (response.outdated_actions !== undefined) {
      Object.keys(response.outdated_actions).forEach((key) => {
        if (response.outdated_actions[key].length > 0) {
          actionsFound = true;
        }
      });
    }
    return actionsFound;
  }

  constructor(props) {
    super(props);
    this.state = {
      error: null,
      isLoaded: false,
      backendData: {},
    };
  }

  componentDidMount() {
    axios
      .get('/sam/todo_list/outdated_actions.json')
      .then((result) => {
        this.setState({
          isLoaded: true,
          backendData: result.data,
        });
      })
      .catch(() => {
        this.setState({
          isLoaded: true,
          error: true,
        });
      });
  }

  render() {
    const { error, isLoaded, backendData } = this.state;

    if (backendData.to_display === false) {
      return null;
    }

    if (error) {
      console.log(t('todolist.outdated_actions.error'));
      return null;
    } if (!isLoaded) {
      return (
        <span>
          <br />
          <Loading small withOverlay={false} />
        </span>
      );
    }
    if (OutdatedActions.anyOutdatedActions(backendData)) {
      if (this.props.notify) {
        this.props.updateToDos();
      }

      const version = backendData.site_version;
      const renderedReportStatusText = t('widget.status.warning');
      const titleText = t('todolist.outdated_actions.title');

      const line1 = t('todolist.outdated_actions.line1', {
        product_name: backendData.is_lmt === true ? t('domains.sam.name_lmt') : t('domains.sam.name'),
        version,
      });
      const line2 = backendData.is_admin === true
        ? t('todolist.outdated_actions.line2_admin')
        : t('todolist.outdated_actions.line2_non_admin', backendData.is_lmt === true ? ({
          product_name: t('domains.sam.name_lmt'),
        }) : ({
          product_name: t('domains.sam.name'),
        }));

      const tasksToDisplay = [];
      const details = [];
      Object.keys(backendData.tasks).forEach((taskId) => {
        if (backendData.outdated_actions[taskId].length > 0) {
          tasksToDisplay.push([taskId, backendData.tasks[taskId].name]);
          details[taskId] = backendData.outdated_actions[taskId];
        }
      });

      const taskList = backendData.is_admin === true
        ? (
          <Accordion>
            {tasksToDisplay.map((task) => (
              <AccordionItem key={task[0]} title={task[1]}>
                <Table>
                  <TableHead>
                    <TableRow header>
                      <TableHeader>{t('todolist.outdated_actions.popup_data_src')}</TableHeader>
                      <TableHeader>{t('todolist.outdated_actions.popup_action_id')}</TableHeader>
                      <TableHeader>{t('todolist.outdated_actions.popup_site_name')}</TableHeader>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {details[task[0]].map((detail) => (
                      <TableRow key={detail.action_id}>
                        <TableData>{detail.ds_name}</TableData>
                        <TableData>{detail.action_id}</TableData>
                        <TableData>{detail.site_name}</TableData>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </AccordionItem>))
            }
          </Accordion>
        )
        : (
          <UnorderedList className="notification_text">
            {tasksToDisplay.map((task) => (
              <ListItem key={task[0]} className="notification_text">
                {task[1]}
              </ListItem>))
            }
          </UnorderedList>
        );

      const subtitleText = (
        <span className="notification_text">
          <span>
            {line1}
          </span>
          <br />
          <span>
            {line2}
          </span>
        </span>
      );

      const captionText = (
        <div>
          {taskList}
          <br />
          <span className="notification_text">
            {t('todolist.outdated_actions.details')}
          </span>
        </div>
      );

      return (
        <div>
          <ToastNotification
            className="notification_style"
            title={titleText}
            subtitle={subtitleText}
            caption={captionText}
            kind="warning"
            hideCloseButton
            aria-label={t('todolist.aria_label', { name: t('todolist.outdated_actions.name'), status: renderedReportStatusText })}
            role="region"
          />
        </div>
      );
    }
    return null;
  }
}

export default OutdatedActions;
